export const en = {
    additions: 'Extensions: {additionsList}'
};
